import FieldMixins from './mixins/field_mixin.js';
import Popover from 'trunks/vue/admin/components/libs/popover.js';
import SearchMixin from 'trunks/vue/admin/components/search/mixin.js';
import SearchList from 'trunks/vue/admin/components/search/search_list.js';
import DebounceInput from 'trunks/vue/admin/components/libs/debounce_input.js';

export default Vue.extend({
  mixins: [FieldMixins, SearchMixin],

  components: {
    Popover,
    'search-list': SearchList,
    'debounce-input': DebounceInput,
  },

  data() {
    return {
      cascadedSelects: [],
      currentCascadedSelect: null,
      keyword: '',
    };
  },

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               :disabledFieldLayout='disabledFieldLayout'
               ref='fieldView'>
      <template slot='content'>
        <div class="edit-content" v-if='editing'>
          <div class="input-container inline cascaded-select-input">
            <Popover position='bottom'
                     :caret='false'
                     :blockContent='true'
                     :manualToggle='true'
                     @triggerClicked='triggerClicked'
                     ref='popoverVm'>
              <template slot='trigger'>
                <input type="text" disabled='true' :value='currentCascadedSelect && currentCascadedSelect.name' placeholder='请选择' />
                <i class="slp-caret-down placeholder"></i>
              </template>
              <template slot='content'>
                <div class="cascaded-select-query-wrapper">
                  <div class="query-input">
                    <debounce-input placeholder='搜索级联选择'
                                    @change='keywordChange'
                                    ref='queryInput'
                                    class='floated' />
                  </div>
                  <search-list :items='cascadedSelects'
                               @valueChanged='optionChanged'
                               ref='searchListVm'>
                    <template slot='option-template' slot-scope='{ item }'>
                      <span class='content'>{{ item.name }}</span>
                      <i class="primary-text" :class='_selectedClass(item)'></i>
                    </template>
                  </search-list>
                </div>
              </template>
            </Popover>
          </div>
        </div>
        <div class="display-content" v-else>
          <div class="input-container inline" v-for='(label, index) in cascadedLabels' :key='index'>
            <div class="input-control placeholder justify-box right-addon">
              <input type="text" readonly :placeholder='"-- " + label + " --"' />
              <div class="addon">
                <i class="slp-caret-down"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="field-leaf-setting mt-2">
          <span>必须选到最后一个层级</span>
          <label class="switch">
            <input type="checkbox" :checked="field.settings.only_leaf" @change="updateLeafEnabled"/>
            <span></span>
          </label>
        </div>
      </template>
      <template slot="replaced-settings">
        <slot name="user-settings" :field="field"></slot>
      </template>
    </FieldView>
  `,

  created() {
    this._fetchCascadedSelects();
  },

  computed: {
    cascadedLabels() {
      if (this.currentCascadedSelect) return this.currentCascadedSelect.labels;
      return [];
    },
  },

  watch: {
    currentCascadedSelect(newVal) {
      if (!newVal) return;
      this.field.cascaded_select_id = newVal.id;
      this.field.cascaded_select = newVal;
      this.keyword = newVal.name;
    },
  },

  methods: {
    optionChanged(cascadedSelect) {
      this.currentCascadedSelect = cascadedSelect;
      this.$refs.popoverVm.close();
    },

    keywordChange(keyword) {
      this.keyword = keyword;
      this._fetchCascadedSelects();
    },

    triggerClicked() {
      if (this.$refs.popoverVm.opened) {
        this.$refs.popoverVm.close();
      } else {
        this.$refs.popoverVm.open();
        this.$refs.popoverVm.$nextTick(() => {
          this.$refs.queryInput.$el.focus();
        });
      }
    },

    validate() {
      if (_.isBlank(this.field.cascaded_select_id)) {
        this.$emit('fieldError', 'cascaded_select', '不能为空');
        return false;
      }
      return true;
    },

    updateLeafEnabled(event) {
      this.field.settings.only_leaf = event.target.checked;
    },

    _selectedClass(item) {
      return item.id === (this.currentCascadedSelect && this.currentCascadedSelect.id) ? 'slp-check' : 'slp-empty';
    },

    _fetchCascadedSelects() {
      const url = Skylark.Helpers.UrlHelper.adminUrlFor('/cascaded_selects.json', { q: this.keyword });
      Skylark.Libs.Ajax.get(url)
        .done((cascadedSelects) => {
          this.cascadedSelects = cascadedSelects;
          if (!this.currentCascadedSelect && this.field.cascaded_select_id) {
            this.currentCascadedSelect = _.findWhere(cascadedSelects, { id: this.field.cascaded_select_id });
          }
        });
    },
  },
});
